import aboutman from '../images/about pic.png'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const About = () => {

let h = '< h1 >';
let ho = '< /h1 >';
let div = ' < div >'
let dc =  '< div/>'

  const styles = {
    marginBottom: '10px',
  };




 return (
          <div>
             <Navbar style={styles}/>
             <div class="about">
  <div class="container">
      <h2 class="headerText">About</h2>
      <div class="row">
          <div class="col-lg-5">
              <div class="about-img">
                  <img src={aboutman} alt="aboutman" class="img-fluid"/>
              </div>
             
          </div>
          <div class="col-lg-7">
              <h3> introduction </h3>
              <div>
                 
                  <h2> <span> {h}</span> Hello im Craig Togarepi <span> {ho} </span></h2> 
                 <span class="tag"> {div} </span>
                  <p>
                      I'm a front-end web developer with a passion for creating engaging 
                      and interactive user experiences.I've honed my skills in HTML, CSS, 
                    JavaScript, and other front-end frameworks to deliver top-notch results.  </p> 
                    <p>
                    What sets me apart is my tenacity and grit. I don't give up until I find a 
                    solution to a problem, and I'm not afraid to dive deep into code to
                    debug and optimise it.  A true problem-solver at heart, always striving 
                    to find the most elegant and efficient solutions. </p> 
                    <p>
                    If you're looking for a front-end developer who is able, skilled, and
                    reliable, I'd love to connect with you. Let's build something great together! 

                  </p>
                  <span class="tag"> {dc} </span>

              </div>
              
              
          </div>
      </div>
  </div>


</div>
   <Footer/>
          </div>
 



 );






  
};
export default About;
